import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {BanPaymentDataType} from '../Constants/banPaymentDataTypeEnum';
import {
  setShowPopup,
  setPaymentAction,
  handleBanData,
  handleCurrentStep,
  setSelectedBansForPaymentUpdate,
  selectServerData,
  selectEpiData,
  setSelectedUpdatePaymentType,
  selectMaxPaymentEnergy,
  selectMaxPayment,
} from '../DebtAndUpdatePaymentBlockSlice';
import {popupEnum, paymentAction, stepEnum} from '../Constants/debtPaymentEnum';
import {isSingleEligibleBanAlreadySelected} from '../utils/updatePaymentBanUtils';
import {dwhUpdatePaymentMethodReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';

/**
 * Shared handler for "לעדכון" on ban list cards (BanPaymentMethodRow, PaymentIssueBanStatus).
 */
export const useBanUpdatePaymentClick = (banData) => {
  const dispatch = useDispatch();
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);
  const maxPaymentEnergy = useSelector(selectMaxPaymentEnergy);
  const maxPayment = useSelector(selectMaxPayment);
  const loginData = useSelector((state) => state.authentication.loginData);
  const paymentType = banData?.paymentData?.paymentType;
  const previousPaymentType = banData?.previousPaymentData?.paymentType;
  const skipBanSelectForCreditCard = useMemo(
    () => isSingleEligibleBanAlreadySelected(allBans, banData?.banNumber),
    [allBans, banData?.banNumber],
  );

  return useCallback(() => {
    dwhUpdatePaymentMethodReport({
      banData,
      loginData,
      allBans,
      actionType: DwhActionType.AccountListPage,
      messageText: DWHMessageText.AccountListPageUpdateButtonClicked,
      status: DWHStatus.Ongoing,
      lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
    });
    dispatch(handleBanData(banData));
    if (banData.hasDebt) {
      if (banData.isEnergy && banData.amount > maxPaymentEnergy) {
        dispatch(setShowPopup({showPopUp: true, popupType: popupEnum.DEBT_FIRST_MAX}));
      } else if (!banData.isEnergy && banData.amount > maxPayment) {
        dispatch(setShowPopup({showPopUp: true, popupType: popupEnum.DEBT_FIRST_MAX}));
      } else {
        dispatch(setShowPopup({showPopUp: true, popupType: popupEnum.DEBT_FIRST}));
      }
    } else {
      dispatch(setPaymentAction(paymentAction.UPDATE_PAYMENT_METHOD));
      if (
        paymentType === BanPaymentDataType.BANK ||
        (paymentType === BanPaymentDataType.DIFFERENT &&
          (!epiData?.lastPaymentTypeValidation || previousPaymentType === BanPaymentDataType.BANK))
      ) {
        dispatch(handleCurrentStep(stepEnum.SELECTUPDATEPAYMENTTYPE));
      } else if (skipBanSelectForCreditCard && banData?.banNumber) {
        dispatch(setSelectedBansForPaymentUpdate([banData.banNumber]));
        dispatch(handleCurrentStep(stepEnum.CREDITCARD));
        dispatch(setSelectedUpdatePaymentType('creditcard'));
      } else {
        dispatch(setSelectedUpdatePaymentType('creditcard'));
        dispatch(handleCurrentStep(stepEnum.SELECTUPDATEPAYMENTBAN));
      }
    }
  }, [banData, dispatch, paymentType, skipBanSelectForCreditCard, epiData?.lastPaymentTypeValidation, allBans, loginData]);
};
